import { AppDispatch } from '../../store'
import { API_CALL } from 'actions/actionConstants'
import requestGetApprovalPolicy from 'businessTraveller/api/requestGetApprovalPolicy'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'

interface Params {
  refetch?: boolean
}

const pendingApprovalPolicyRequestKeys = new Set<string>()

function fetchBusinessApprovalPolicy(
  businessId: string,
  params?: Params,
) {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()

    const policy = state.businessTraveller.businessApprovalPolicy.policy
    const currentBusinessUser = state.businessTraveller.currentBusinessAccount?.employee
    const requestKey = currentBusinessUser ? `${businessId}:${currentBusinessUser.id}` : undefined

    const shouldFetch = currentBusinessUser && requestKey && !pendingApprovalPolicyRequestKeys.has(requestKey) && (!policy || params?.refetch)
    if (shouldFetch) {
      pendingApprovalPolicyRequestKeys.add(requestKey)
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_BUSINESS_APPROVAL_POLICY,
        request: () => requestGetApprovalPolicy({ businessId })
          .finally(() => {
            pendingApprovalPolicyRequestKeys.delete(requestKey)
          }),
      })
    }
  }
}

export default fetchBusinessApprovalPolicy
